export default __webpack_public_path__ + "static/media/service-line.e14d793c.svg";